import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {EmptyPaginator, PaginatorModel} from "../../interfaces/PaginatorModel";

const PAGING_DISPLAY_LIMIT = 5;

@Component({
	selector: 'app-pagination',
	templateUrl: './pagination.component.html',
	styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
	@Input() paginator: PaginatorModel = EmptyPaginator;
	@Output() selectedPage = new EventEmitter();

	constructor() {
	}

	ngOnInit(): void {
	}

	public createRange(number: number) {
		return new Array(number).fill(0)
			.map((n, index) => index);
	}

	public pagingDisplayRange(page: number) {
		const max = page + PAGING_DISPLAY_LIMIT;
		const min = page - PAGING_DISPLAY_LIMIT;
		// @ts-ignore
		const arr = Array.apply(null, {length: max + 1 - min}).map(function (_, idx) {
			return idx + min;
		});

		return arr;
	}

	public currentPage(): number {
		if (this.hasNextPage()) {
			// @ts-ignore
			return this.paginator.nextPage - 1;
		}

		if (this.hasPreviousPage()) {
			// @ts-ignore
			return this.paginator.previousPage + 1;
		}

		return 0;
	}

	public hasNextPage(): boolean {
		// @ts-ignore
		return (this.paginator?.nextPage > 0);
	}

	public hasPreviousPage(): boolean {
		// @ts-ignore
		return (this.paginator?.previousPage >= 0);
	}

	public pageChange(page: number) {
		if (page === this.currentPage()) {
			return;
		}

		this.selectedPage.emit(page);
	}

	public previousPage(page: number) {
		if (!this.hasPreviousPage()) {
			return;
		}

		this.selectedPage.emit(page);
	}

	public nextPage(page: number) {
		if (!this.hasNextPage()) {
			return;
		}

		this.selectedPage.emit(page);
	}
}
